import type { SurveyCategory } from './types';

export function detectCategoryFromPath(pathname: string): SurveyCategory {
  return pathname.startsWith('/evaluations') ? 'evaluation' : 'survey';
}

export function getAssessmentListPath(category?: SurveyCategory | null): string {
  return category === 'evaluation' ? '/evaluations' : '/surveys';
}

export function getAssessmentListLabel(category?: SurveyCategory | null): string {
  return category === 'evaluation' ? 'Evaluaciones' : 'Encuestas';
}

export function getAssessmentSingularLabel(category?: SurveyCategory | null): string {
  return category === 'evaluation' ? 'evaluación' : 'encuesta';
}

export function getAssessmentResponsesTitle(category?: SurveyCategory | null): string {
  return category === 'evaluation' ? 'Respuestas de Evaluación' : 'Respuestas de Encuesta';
}

export function getAssessmentStatisticsTitle(category?: SurveyCategory | null): string {
  return category === 'evaluation' ? 'Estadísticas de Evaluación' : 'Estadísticas de Encuesta';
}
